export function removeAccents(str: string): string {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function replaceFileNotAllowedCharacters(
  str: string,
  replacement: string
): string {
  return str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, replacement);
}
